import { cn } from "../../../util/cn";

export const HintsLink = ({
  className,
  children,
  ...rest
}: React.ComponentProps<"a">) => {
  return (
    <a
      className={cn(
        "underline underline-offset-2 hover:decoration-primary",
        className
      )}
      {...rest}
    >
      {children}
    </a>
  );
};
